// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__399b4","col":"styles_col__2tkv2","actions":"styles_actions__2eUYR","conflict":"styles_conflict__1AWEI"};